import { render, staticRenderFns } from "./no-tags.vue?vue&type=template&id=85bcb47a&scoped=true"
var script = {}
import style0 from "./no-tags.vue?vue&type=style&index=0&id=85bcb47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bcb47a",
  null
  
)

export default component.exports